import ArticleIcon from '@mui/icons-material/Article';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleIcon from '@mui/icons-material/People';
import {
  Box,
  Container,
  List, ListItem,
  ListItemButton, ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery, useTheme
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { collection, getDocs, query, where } from 'firebase/firestore';
import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import ResponsiveJoinedAppBar from "../AppBarLoggedIn";
import EventDetailsCompact from "../../components/EventDetailsCompact";
import PeopleAvatarGroup from '../../components/PeopleAvatarGroup';
import ResourcesListCompact from '../ResourcesListCompact';
import { db } from '../../firebase';

// Create Theme Context
const ThemeContext = createContext();

const PeoplePage = () => {
        
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down("lg"));
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { eventCode } = useParams();  // Capture the eventCode from the URL
    const [eventDetails, setEventDetails] = useState(null);
    const [eventDocId, setEventDocId] = useState(null);
    const [error, setError] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (eventCode) {
          fetchEvent(eventCode);
        }
      }, [eventCode]);      
    
      const fetchEvent = async (code) => {
        try {
          setError('');
          setEventDetails(null);
          setEventDocId(null);
    
          // Find the event document by eventCode
          const eventsRef = collection(db, 'events');
          const eventQuery = query(eventsRef, where('eventCode', '==', code));
          const eventSnapshot = await getDocs(eventQuery);
    
          if (!eventSnapshot.empty) {
            // Assume the first matching event document
            const eventDoc = eventSnapshot.docs[0];
            const eventData = eventDoc.data();

            // Setting the page title 
            {document.title = "nKuvu - " + eventData.eventName}
    
            setEventDocId(eventDoc.id);  // Store document ID for post retrieval
            setEventDetails({
              eventImage: eventData.eventImageURL,
              eventName: eventData.eventName,
              eventCode: eventData.eventCode,
              eventOwnerName: eventData.eventOwnerName,
            });
          } else {
            setError('No event found with that event code.');
          }
        } catch (err) {
          console.error("Error fetching event:", err);
          setError('Failed to retrieve event data.');
        }
      };
    
  return (
    
    <Box 
     sx={{ display: "flex", 
      flexDirection: "column",       
      bgcolor: "grey.200", }}>        
     
     <ResourcesListCompact eventDocId={eventDocId}/>
    </Box>
  );
};

// Theme Provider Wrapper
const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
  });

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <ThemeProvider theme={theme}>
        <PeoplePage />
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default App;
